import { DATASOURCE } from "../../constants/action-types";
const initialState = {
    dataSourcesDataTable: [],
    peopleByFirstSource: [],
    peopleByLastSource: [],
    lifeValueByFirstSource: [],
    lifeValueByLastSource: [],
    loadedSources: [],
    peopleFromThisSource: [],
    percentagePeopleBySource: [],
    percentageCustomerBySource: [],
    percentageDatabaseBySource: [],
    percentageRevenueBySource: []
}

const DataSourceReducer = (state = initialState, action) => {
    switch (action.type) {
        case DATASOURCE.REVENUE_PERCENTAGE_BY_SOURCES_UPDATE: {
            return Object.assign({}, state, {
                percentageRevenueBySource: action.payload
            });

        }
        case DATASOURCE.DATABASE_PERCENTAGE_BY_SOURCES_UPDATE: {
            return Object.assign({}, state, {
                percentageDatabaseBySource: action.payload
            });

        }
        case DATASOURCE.CUSTOMER_PERCENTAGE_BY_SOURCES_UPDATE: {
            return Object.assign({}, state, {
                percentageCustomerBySource: action.payload
            });

        }
        case DATASOURCE.PEOPLE_PERCENTAGE_BY_SOURCES_UPDATE: {
            return Object.assign({}, state, {
                percentagePeopleBySource: action.payload
            });

        }
        case DATASOURCE.UPDATE_DATASOURCES_VENN_DIAGRAM_DATA: {
            return Object.assign({}, state, {
                peopleFromThisSource: action.payload
            });

        }
        case DATASOURCE.LOAD_DATA_SOURCES_LIST: {
            return Object.assign({}, state, {
                loadedSources: action.payload
            });

        }
        case DATASOURCE.UPDATE_LIFE_VALUE_BY_LAST_SOURCE: {
            return Object.assign({}, state, {
                lifeValueByLastSource: action.payload
            });

        }
        case DATASOURCE.UPDATE_LIFE_VALUE_BY_FIRST_SOURCE: {
            return Object.assign({}, state, {
                lifeValueByFirstSource: action.payload
            });

        }
        case DATASOURCE.UPDATE_PEOPLE_BY_LAST_SOURCE: {
            return Object.assign({}, state, {
                peopleByLastSource: action.payload
            });

        }
        case DATASOURCE.UPDATE_PEOPLE_BY_FIRST_SOURCE: {
            return Object.assign({}, state, {
                peopleByFirstSource: action.payload
            });

        }
        case DATASOURCE.UPDATE_DATASOURCES_TABLE_DATA: {
            return Object.assign({}, state, {
                dataSourcesDataTable: action.payload
            });

        }



        default:
            return state
    }

}

export default DataSourceReducer